import React from "react";
import "./we-have-moved.scss";

const PORTAL_URL = "https://patient.verkind.co.uk/login";
const WEBSITE_URL = "https://verkind.co.uk/";

const Logo = () => (
    <img className="wehavemoved__logo" src="/images/verkind-logo.png" alt="Verkind" />
);

export default function WeHaveMovedPage() {
    return (
        <main className="wehavemoved">
            <div className="wehavemoved__inner">
                <h1 className="wehavemoved__heading">
                    Hello, Treat It Clinic is now <Logo />
                </h1>

                <p className="wehavemoved__body">
                    Treat It Clinic has changed its name to <Logo />.
                </p>
                <p className="wehavemoved__body">
                    The Treat It website and portal are now closed.
                </p>

                <nav className="wehavemoved__links">
                    <a
                        className="wehavemoved__link wehavemoved__link--secondary"
                        href={WEBSITE_URL}
                    >
                        Visit the new website
                    </a>
                    <a
                        className="wehavemoved__link wehavemoved__link--primary"
                        href={PORTAL_URL}
                    >
                        Visit the new patient portal
                    </a>
                </nav>
            </div>
        </main>
    );
}
